/**
 * Fixed header stack — hide announcement bar on scroll, keep nav pinned.
 */
(function () {
  'use strict';

  var SCROLL_THRESHOLD = 8;
  var hasPrimedOffset = false;

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function updateHeaderScroll() {
    var scrollY = getScrollY();
    var scrolled = scrollY > SCROLL_THRESHOLD;
    var root = document.documentElement;
    var body = document.body;
    var bar = document.querySelector('[data-announcement-bar]');
    var nav = document.querySelector('[data-fabpad-nav]');

    var announcementHeight = bar && !scrolled ? bar.offsetHeight : 0;
    var navHeight = nav ? nav.offsetHeight : 0;
    var stackHeight = announcementHeight + navHeight;

    /* First measure snaps — body padding-top transition would slide the PDP gallery/count */
    if (!hasPrimedOffset && body) {
      body.style.transition = 'none';
    }

    /* Snap nav position before toggling announcement visibility — avoids staggered reveal */
    root.style.setProperty('--fabpad-announcement-offset', announcementHeight + 'px');
    root.style.setProperty('--fabpad-header-offset', stackHeight + 'px');
    root.style.setProperty('--fabpad-sticky-top', stackHeight + 'px');

    if (!hasPrimedOffset && body) {
      void body.offsetHeight;
      body.style.transition = '';
      hasPrimedOffset = true;
    }

    root.classList.toggle('fabpad-header-scrolled', scrolled);

    if (bar) {
      bar.classList.toggle('is-scrolled-away', scrolled);
      bar.setAttribute('aria-hidden', scrolled ? 'true' : 'false');
    }

    if (nav) {
      nav.classList.toggle('nav-scrolled', scrollY > 60);
    }
  }

  function init() {
    updateHeaderScroll();
    window.addEventListener('scroll', updateHeaderScroll, { passive: true });
    window.addEventListener('resize', updateHeaderScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
